import { render, staticRenderFns } from "./TaxRanges.vue?vue&type=template&id=27277844&"
import script from "./TaxRanges.vue?vue&type=script&lang=js&"
export * from "./TaxRanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports